import router from '../../router'

export const generateLink = {
    state: {
        linkUuid: null,
        generatedLink: null
    },
    mutations: {
        SET_GENERATED_LINK_UUID(state, payload) {
            state.linkUuid = payload
        },
        SET_GENERATED_LINK(state, payload) {
            state.generatedLink = payload
        }
    },
    actions: {
        saveGeneratedLink({ commit, getters, dispatch }) {
            const route = router.currentRoute

            const moduleName =
                route.meta && route.meta.moduleName
                    ? route.meta.moduleName
                    : route.name

            const getterFilters = `get${moduleName[0].toUpperCase() +
                moduleName.slice(1)}Filters`
            const filters = getterFilters
                ? typeof getters[getterFilters] === 'function'
                    ? getters[getterFilters]()
                    : getters[getterFilters]
                : []

            const getterSort = `get${moduleName[0].toUpperCase() +
                moduleName.slice(1)}Sort`
            const sort = getterSort ? getters[getterSort] : []

            const getterPagination = `get${moduleName[0].toUpperCase() +
                moduleName.slice(1)}Pagination`
            const pagination = getterSort ? getters[getterPagination] : []

            const hash = window.location.hash ? window.location.hash : ''

            const urlObj = new URL(window.location.href)
            const params = new URLSearchParams(urlObj.search)
            const queryParams = Object.fromEntries(params.entries())

            for (const [key, value] of Object.entries(queryParams)) {
                if (filters[key] && !filters[key.value]) {
                    filters[key].value = value
                }
            }

            return this.$api
                .post('saveGeneratedLink', {
                    url: {
                        path: route.path,
                        fullPath: route.fullPath,
                        name: route.name,
                        params: route.params,
                        hash
                    },
                    filters: filters || {},
                    sorts: sort || {},
                    paginations: pagination || {}
                })
                .then(res => {
                    if (res && res.status === 200) {
                        const linkUuid = res.data.data.uuid
                        const generatedLink =
                            window.location.protocol +
                            '//' +
                            window.location.host +
                            '/link/' +
                            linkUuid
                        commit('SET_GENERATED_LINK_UUID', linkUuid)
                        navigator.clipboard.writeText(generatedLink)
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Skopiowano link do schowka.'
                        })
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            content: 'Wystąpił błąd. Spróbuj ponownie później.'
                        })
                    }
                    return res
                })
                .catch(err => {
                    console.log(err)
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                })
        },
        setGeneratedLinkUuid({ commit }, payload) {
            commit('SET_GENERATED_LINK_UUID', payload)
        },
        removeGeneratedLink({ commit }) {
            commit('SET_GENERATED_LINK', null)
            this.$storage.removeItem('generatedLink')
        },
        setGeneratedLink({ commit }, payload) {
            commit('SET_GENERATED_LINK', payload)
            this.$storage.setItem('generatedLink', payload)
        },
        getGeneratedLink({ commit, dispatch }, payload) {
            return this.$api
                .get('getGeneratedLink/' + payload)
                .then(res => {
                    if (res && res.status === 200) {
                        dispatch('setGeneratedLink', res.data.data)
                    } else {
                        dispatch('addNotification', {
                            type: 'danger',
                            content:
                                'Nie udało się wygenerować adresu URL. Spróbuj ponownie później.'
                        })
                    }
                    return res
                })
                .catch(err => {
                    dispatch('addNotification', {
                        type: 'danger',
                        content:
                            'Nie udało się wygenerować adresu URL. Spróbuj ponownie później.'
                    })
                })
        },
        async goToGeneratedLink({ state, dispatch, getters }) {
            const generatedLink = await this.$storage.getItem('generatedLink')
            let route = router.resolve({ name: generatedLink.url.name })

            if (route) {
                route = route.route

                const moduleName =
                    route.meta && route.meta.moduleName
                        ? route.meta.moduleName
                        : route.name

                if (
                    this._actions[
                        `set${moduleName[0].toUpperCase() +
                            moduleName.slice(1)}Pagination`
                    ]
                ) {
                    dispatch(
                        `set${moduleName[0].toUpperCase() +
                            moduleName.slice(1)}Pagination`,
                        generatedLink.paginations
                    )
                }

                if (generatedLink.filters) {
                    const filters = Object.entries(
                        generatedLink.filters
                    ).reduce((obj, key) => {
                        const generatedFilter = generatedLink.filters[key[0]]
                        obj[key[0]] = generatedFilter
                        if (key[1].disabledLinkGenerator && key[1].value) {
                            if (
                                getters.getMerchantsForSelect &&
                                generatedFilter.value
                            ) {
                                const merchantIds = getters.getMerchantsForSelect.map(
                                    el => el.value
                                )
                                if (typeof generatedFilter.value === 'object') {
                                    if (
                                        generatedFilter.value.some(
                                            el => !merchantIds.includes(el)
                                        )
                                    ) {
                                        generatedFilter.value = []
                                    }
                                }
                                if (
                                    typeof generatedFilter.value === 'string' ||
                                    typeof generatedFilter.value === 'number'
                                ) {
                                    if (
                                        !merchantIds.includes(
                                            generatedFilter.value
                                        )
                                    ) {
                                        generatedFilter.value = null
                                    }
                                }
                                obj[key[0]] = generatedFilter
                            }
                        }
                        return obj
                    }, {})

                    dispatch('setFilters', {
                        moduleName,
                        filters
                    })
                }

                if (
                    this._actions[
                        `set${moduleName[0].toUpperCase() +
                            moduleName.slice(1)}Sort`
                    ]
                ) {
                    dispatch(
                        `set${moduleName[0].toUpperCase() +
                            moduleName.slice(1)}Sort`,
                        generatedLink.sorts
                    )
                }

                dispatch('removeGeneratedLink')
                await router.push(
                    generatedLink.url.path + generatedLink.url.hash
                )
            }
        }
    },
    getters: {
        getGeneratedLinkUuid: state => {
            return state.linkUuid
        },
        getGeneratedLink: state => {
            return state.generatedLink
        }
    }
}
